import { Box, Divider, Group, Modal, ScrollArea } from '@mantine/core';
import { useForm } from '@mantine/form';
import PermissionInput from 'components/inputs/permission-input/PermissionInput';
import { useResponsiveDesign } from 'hooks/use-responsive-design';
import Button from 'components/Button';
import {
  ALL_ORGANIZATION_MODULES_ENABLED,
  OrganizationModuleFlags,
} from 'features/organization-modules/use-organization-modules';

interface PickGlobalPermissionsModalProps {
  title: string;
  opened: boolean;
  initialPermissions: number[];
  onClose: () => void;
  onPick: (permissions: number[]) => void;
  moduleFlags?: OrganizationModuleFlags;
}

interface FormValues {
  permissions: number[];
}

/**
 * Modal for editing direct global permissions.
 */
export default function PickGlobalPermissionsModal({
  title,
  opened,
  initialPermissions,
  onClose,
  onPick,
  moduleFlags = ALL_ORGANIZATION_MODULES_ENABLED,
}: PickGlobalPermissionsModalProps) {
  const { isTablet } = useResponsiveDesign();
  const form = useForm<FormValues>({
    initialValues: {
      permissions: initialPermissions,
    },
  });

  /**
   * Submits the edited permissions.
   */
  function submit({ permissions }: FormValues) {
    onPick(permissions);
    onClose();
  }

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Divider color="gray.1" mb={24} />
      <form onSubmit={form.onSubmit(submit)}>
        <ScrollArea h={400}>
          <Box pb={24}>
            <PermissionInput
              permissionType="global"
              value={form.values.permissions}
              onChange={(permissions) => form.setFieldValue('permissions', permissions)}
              moduleFlags={moduleFlags}
            />
          </Box>
        </ScrollArea>
        <Group spacing={isTablet ? 20 : 40} position="apart" mt={24}>
          <Button variant="subtle-gray" type="button" onClick={onClose}>
            Zrušiť
          </Button>
          <Button variant="primary" size="md" type="submit">
            Uložiť
          </Button>
        </Group>
      </form>
    </Modal>
  );
}
